import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { attachFormVersion } from '../../../core';
export var MULTIPLE_CHOICE_QUESTION_API = 'MULTIPLE_CHOICE_QUESTION_API';
export var MultipleChoiceQuestionApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(MultipleChoiceQuestionApi, _AxiosApi);

  var _super = _createSuper(MultipleChoiceQuestionApi);

  function MultipleChoiceQuestionApi(axiosInstance, mapper) {
    var _this;

    _classCallCheck(this, MultipleChoiceQuestionApi);

    _this = _super.call(this, 'multiple-choice-questions', axiosInstance);
    _this.mapper = mapper;
    return _this;
  }

  _createClass(MultipleChoiceQuestionApi, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(question) {
        var url, dto, jsonResponse, parsedResponseBody, questionDto;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url);
                dto = this.mapper.fromDomain(question);
                _context.next = 5;
                return this.axios.post(url, dto);

              case 5:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                questionDto = parsedResponseBody.data;

                if (!(questionDto.id !== question.id.toString())) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", new BadInputError('Created Question does not match'));

              case 10:
                return _context.abrupt("return", Result.ok(attachFormVersion(question, questionDto.formVersion)));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(question) {
        var _parsedResponseBody$d, url, dto, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/").concat(question.id);
                dto = this.mapper.fromDomain(question);
                _context2.next = 5;
                return this.axios.put(url, dto);

              case 5:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(attachFormVersion(question, (_parsedResponseBody$d = parsedResponseBody.data) === null || _parsedResponseBody$d === void 0 ? void 0 : _parsedResponseBody$d.formVersion)));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function update(_x2) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return MultipleChoiceQuestionApi;
}(AxiosApi);